import { useToastStore } from '../../stores/useToastStore'

const STYLES = {
  error: 'bg-red-600 text-white',
  success: 'bg-green-700 text-white',
  info: 'bg-secondary text-white',
  warning: 'bg-primary text-white',
}

export default function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  const removeToast = useToastStore((s) => s.removeToast)

  if (toasts.length === 0) return null

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`px-4 py-3 rounded-lg shadow-lg text-sm font-medium flex items-start gap-2 animate-slide-in-right ${STYLES[toast.type] || STYLES.info}`}
        >
          <span className="flex-1">{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            className="opacity-70 hover:opacity-100 shrink-0 text-lg leading-none"
            aria-label="Fermer"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  )
}
